<div class="notes-tab">
  <textarea nbInput
            fullWidth
            rows="14"
            maxlength="20000"
            data-cy="inspection-notes-textarea"
            placeholder="Rundgangsnotizen zu dieser Begehung..."
            [formControl]="noteControl"></textarea>
  <div class="actions">
    <button nbButton
            status="primary"
            data-cy="inspection-notes-save"
            [disabled]="saving() || !noteControl.dirty"
            (click)="save()">
      <nb-icon icon="save-outline" pack="eva"></nb-icon>
      Speichern
    </button>
  </div>
</div>
